<div *ngIf="resultsPageGrid && resultsPageGrid.filtersForm">
  <!-- Search Filter -->
  <div class="d-flex flex-wrap m-3">
    <div class="col-md-6 col-sm-12">
      <input type="text" class="form-control" [disabled]="gridInProgress"
        [formControl]="resultsPageGrid.filtersForm.get('searchUsers')" placeholder="Search verification codes..." />
    </div>
    <div class="col-md-6 col-sm-12 text-end">
      <button class="btn btn-primary" (click)="refreshDataList()"><i class="fa fa-refresh"></i> Refresh</button>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="gridInProgress" class="d-flex justify-content-center p-3">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Material Table -->
  <div *ngIf="!gridInProgress && resultsPageGrid" class="stripe-table">
    <table mat-table [dataSource]="resultsPageGrid.dataSource" matSort
      class="mat-elevation-z1 mat-table mat-small clean-table">
      <!-- NIC/PP/BRN Column -->
      <ng-container matColumnDef="nic">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">NIC/PP/BRN</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          {{ element.nic ? element.nic : element.passport ? element.passport : element.brn }}
        </td>
      </ng-container>

      <!-- Email Data Column -->
      <ng-container matColumnDef="emailData">
        <th mat-header-cell *matHeaderCellDef class="text-center">Email Data</th>
        <td mat-cell *matCellDef="let element">
          <div class="email-data-group">
            <div class="email-info"><strong>Email:</strong> {{ element.email || 'N/A' }}</div>
            <div class="email-info"><strong>Sent Time:</strong> {{ element.emailCodeSentTime || 'N/A' }}</div>
            <div class="email-info"><strong>Code:</strong> {{ element.emailCode || 'N/A' }}</div>
          </div>
        </td>
      </ng-container>

      <!-- Mobile Data Column -->
      <ng-container matColumnDef="mobileData">
        <th mat-header-cell *matHeaderCellDef class="text-center">Mobile Data</th>
        <td mat-cell *matCellDef="let element">
          <div class="mobile-data-group">
            <div class="mobile-info"><strong>Mobile:</strong> {{ element.mobile || 'N/A' }}</div>
            <div class="mobile-info"><strong>Sent Time:</strong> {{ element.mobileCodeSentTime || 'N/A' }}</div>
            <div class="mobile-info"><strong>Code:</strong> {{ element.mobileCode || 'N/A' }}</div>
          </div>
        </td>
      </ng-container>

      <!-- Verification Data Column -->
      <ng-container matColumnDef="verificationData">
        <th mat-header-cell *matHeaderCellDef class="text-center">Verification Data</th>
        <td mat-cell *matCellDef="let element">
          <div class="verification-data-group">
            <div class="verification-info"><strong>Invalid Attempts:</strong> {{ element.invalidVerificationAttempts ||
              '0' }}</div>
            <div class="verification-info"><strong>Request Count:</strong> {{ element.verificationCodeRequestCount ||
              '0' }}</div>
          </div>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <button class="btn btn-danger btn-sm" (click)="deleteVerificationCode(element.id)"
            matTooltip="Delete verification code">
            <i class="fa fa-trash"></i> Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- No Data Message -->
    <div *ngIf="!gridInProgress && resultsPageGrid && resultsPageGrid.dataSource.data.length === 0"
      class="text-center p-4">
      <p class="text-muted">No verification codes found</p>
    </div>

    <!-- Paginator -->
    <mat-paginator [pageSizeOptions]="[15, 25, 50, 100]" [pageSize]="resultsPageGrid.pageSize"
      [length]="resultsPageGrid.total" [pageIndex]="resultsPageGrid.pageIndex"
      (page)="resultsPageGrid.onPaginate($event)" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>